export function deepCopy(obj) {
    if (obj === undefined) {
        return;
    }
    return JSON.parse(JSON.stringify(obj))
};